// Browser auto-translation guard.
//
// Safari Translate / Google Translate replace text nodes in the live DOM. React
// still holds references to the original nodes, so the next update throws
// "NotFoundError: Failed to execute 'removeChild'/'insertBefore' on 'Node'" and
// the whole app unmounts — the user sees a blank (here: black) page.
// Making these two DOM methods fault tolerant keeps the app alive while
// translation stays available for foreign-language customers.

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let reported = false;

const reportOnce = (kind) => {
  if (reported) return;
  reported = true;
  try {
    fetch(`${API}/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: `TRANSLATE_GUARD ${kind} (Absturz verhindert)`,
        stack: "",
        component_stack: "",
        url: window.location.href,
        user_agent: navigator.userAgent,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never break rendering because of diagnostics */
  }
};

export function installTranslateGuard() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      reportOnce("removeChild");
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      reportOnce("insertBefore");
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
